import { render, staticRenderFns } from "./VideoJS.vue?vue&type=template&id=68c8fdaa&"
import script from "./VideoJS.vue?vue&type=script&lang=js&"
export * from "./VideoJS.vue?vue&type=script&lang=js&"
import style0 from "./VideoJS.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports